import { render, staticRenderFns } from "./Banner.html?vue&type=template&id=b15f7a2a&scoped=true&external"
import script from "./Banner.js?vue&type=script&lang=js&external"
export * from "./Banner.js?vue&type=script&lang=js&external"
import style0 from "./Banner.scss?vue&type=style&index=0&id=b15f7a2a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15f7a2a",
  null
  
)

export default component.exports